import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from 'core/services/http-data.service';
import { Observable } from 'rxjs';

@Injectable()
export class QuestionsStatsService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/crawler/mars/groupQuestions');
  }

  getGroupQuestionsStats(options?: any): Observable<any> {
    const url = this.baseUrl + '/stats?groupId=' + options.groupId;
    return this.fetchRequest(url, this.getRequestOptions(options), null);
  }
}
